import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';
import LoginRegister from "../LoginRegister/LoginRegister"
import ChatHistory from "../App/ChatHistory"
import ImpressumPage from "../Impressum/ImpressumPage"
import TermsAndPrivacyPage from "../TermsAndPrivacy/TermsAndPrivacyPage"
import { PaymentSuccessPage, PaymentCancelPage } from '../NewPages/PaymentReturnPages';
import { CancelSubscriptionPage } from '../NewPages/CancelSubscriptionPage';

import { BootstrapWorkflows } from '../NewPages/BootstrapWorkflows';
import { BootstrapAnalytics } from '../NewPages/BootstrapAnalytics';
import { BootstrapInterfaceBuilder } from '../NewPages/BootstrapInterfaceBuilder';
import { BootstrapSettings } from '../NewPages/BootstrapSettings';
import { BillingPage } from '../NewPages/BillingPage';
import MarketPlace from '../Marketplace/MarketPlace';
import { CategoryAppsPage } from '../Apps/CategoryAppsPage';

import { WorkflowEditorPageWithLoading } from '../../components/LazyComponents';
import ImageGeneration from '../App/ImageGeneration';
import VideoGeneration from '../App/VideoGeneration';
import DocumentToPDF from '../App/OcrTool';
import VisionModel from '../App/VisionModel';
import ImageToGifGeneration from '../App/ImageToGifGeneration';
import ImageToVideoGeneration from '../App/ImageToVideoGeneration';
import PromptChecker from '../App/PromptChecker';
import SEOCheckerApp from '../App/SEOChecker';
import RagBot from '../App/RagBot';
import SpeechToText from '../App/SpeechToText';
import ImageToImageEdit from '../App/ImageToImageEdit';
import ImageToImageInPaint from '../App/ImageToImageInPaint';
import ImageStudio from '../App/ImageStudio';


export const PageRoutes = () => {
  return (
    <Routes>
      {/* Auth */}
      <Route path='/login' element={<LoginRegister />} />
      <Route path='/' element={<Navigate to="/chat" replace />} />

      {/* Default app */}
      <Route path='/chat' element={<ProtectedRoute><ChatHistory /></ProtectedRoute>} />

      {/* App categories */}
      <Route path='/apps/:category' element={<ProtectedRoute><CategoryAppsPage /></ProtectedRoute>} />

      {/* Individual apps (keep existing routes for direct linking) */}
      <Route path="/executions/1" element={<Navigate to="/chat" replace />} />
      <Route path="/executions/2" element={<ProtectedRoute><ImageGeneration /></ProtectedRoute>} />
      <Route path="/executions/3" element={<ProtectedRoute><VideoGeneration /></ProtectedRoute>} />
      <Route path="/executions/4" element={<ProtectedRoute><DocumentToPDF /></ProtectedRoute>} />
      <Route path="/executions/5" element={<ProtectedRoute><VisionModel /></ProtectedRoute>} />
      <Route path="/executions/6" element={<ProtectedRoute><ImageToGifGeneration /></ProtectedRoute>} />
      <Route path="/executions/7" element={<ProtectedRoute><ImageToVideoGeneration /></ProtectedRoute>} />
      <Route path="/executions/8" element={<ProtectedRoute><PromptChecker /></ProtectedRoute>} />
      <Route path="/executions/9" element={<ProtectedRoute><SEOCheckerApp /></ProtectedRoute>} />
      <Route path="/executions/10" element={<ProtectedRoute><RagBot /></ProtectedRoute>} />
      <Route path="/executions/11" element={<ProtectedRoute><SpeechToText /></ProtectedRoute>} />
      <Route path="/executions/12" element={<ProtectedRoute><ImageToImageEdit /></ProtectedRoute>} />
      <Route path="/executions/13" element={<ProtectedRoute><ImageToImageInPaint /></ProtectedRoute>} />
      <Route path="/executions/14" element={<ProtectedRoute><ImageStudio /></ProtectedRoute>} />
      <Route path="/executions" element={<Navigate to="/apps/knowledge" replace />} />

      {/* Platform pages */}
      <Route path="/dashboard" element={<Navigate to="/analytics" replace />} />
      <Route path="/analytics" element={<ProtectedRoute><BootstrapAnalytics /></ProtectedRoute>} />
      <Route path="/workflows" element={<ProtectedRoute><BootstrapWorkflows /></ProtectedRoute>} />
      <Route path="/workflows/:id" element={<ProtectedRoute><WorkflowEditorPageWithLoading /></ProtectedRoute>} />
      <Route path="/workflows/new" element={<ProtectedRoute><WorkflowEditorPageWithLoading /></ProtectedRoute>} />
      <Route path="/interface-builder" element={<ProtectedRoute><BootstrapInterfaceBuilder /></ProtectedRoute>} />
      <Route path="/marketplace" element={<ProtectedRoute><MarketPlace /></ProtectedRoute>} />
      <Route path="/store" element={<Navigate to="/marketplace" replace />} />
      <Route path="/billing" element={<ProtectedRoute><BillingPage /></ProtectedRoute>} />
      <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccessPage /></ProtectedRoute>} />
      <Route path="/payment/cancel" element={<ProtectedRoute><PaymentCancelPage /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><BootstrapSettings /></ProtectedRoute>} />

      {/* Legal */}
      <Route path='/impressum' element={<ImpressumPage />} />
      <Route path='/terms' element={<TermsAndPrivacyPage />} />
      {/* § 312k BGB: muss OHNE Login erreichbar sein - kein ProtectedRoute! */}
      <Route path='/kuendigung' element={<CancelSubscriptionPage />} />
      <Route path='/subscription' element={<Navigate to="/billing" replace />} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
